// API configuration and base URL
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

// API endpoints (relative paths - baseURL is set in apiService) 
export const ENDPOINTS = {
  // Auth
  LOGIN: '/api/v1/auth/login',
  REGISTER: '/api/v1/auth/register',
  LOGOUT: '/api/v1/auth/logout',
  
  // Users
  ME: '/api/v1/users/me',
  UPDATE_PROFILE: '/api/v1/users/me',
  
  // Courses
  COURSES: '/api/v1/courses/',
  COURSE_DETAIL: (code: string) => `/api/v1/courses/${code}`,
  SYNC_COURSES: '/api/v1/courses/sync',
  COURSE_LOOKUP: '/api/v1/courses/lookup',
  
  // Schedules
  SCHEDULES: '/api/v1/schedules/',
  SCHEDULE_DETAIL: (id: number) => `/api/v1/schedules/${id}`,
  
  // Transcripts
  TRANSCRIPTS: '/api/v1/transcripts/',
  UPLOAD_TRANSCRIPT: '/api/v1/transcripts/upload',
  TRANSCRIPT_DETAIL: (id: number) => `/api/v1/transcripts/${id}`,
  
  // Advisor
  ADVISOR_QUERY: '/api/v1/advisor/query',
  ADVISOR_RECOMMENDATIONS: '/api/v1/advisor/recommendations',
};

// Storage keys
export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'access_token',
  USER: 'user',
};
